import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import Swal from 'sweetalert2';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';


@Component({
  selector: 'app-loan-report',
  templateUrl: './loan-report.component.html',
  styleUrls: ['./loan-report.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, LoaderComponent]
})
export class LoanReportComponent implements OnInit {
  public showSpinner = false;
  loans: any;
  status: any;
  loan_id: any;
  action: any;
  public user: any = [];
  selectimg: any;
  loanDetail: any;
  totalAmount: any;
  total_duration: any;
  paid_installment: any;
  remaining_amount: any;
  remaining_months: any;
  id: any;
  circles: any;
  modalData: any;
  nameFilter = '';
  startDateFilter: any;
  endDateFilter: any;
  userInfo: any;
  colormode: any;
  selectedMode: any;
  datamode: any;

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private addService: AddService,
    public dashboardService: DashboardService,
    private sharedmode: SharedModeService,

  ) {

    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.user_detail();
    const user_role = JSON.parse(this.user.user_role.user_roles)
    if (user_role.role_type != "Admin" && user_role.role_type != "Admin_AND_Team_Lead") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.showloans();
    // this.approveLoan(this.loan_id, this.action)
    // this.isLoanRejectPermission()
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
  }

  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }
  showloans() {
    this.showSpinner = true;
    this.addService.getLoans().then((value) => {

      this.loans = this.transform(value.data);
      this.showSpinner = false;
    })
  }
  transform(loans: any[]): any[] {

    if (!Array.isArray(loans)) {
      return loans;
    }
    const statusOrder = ['pending', 'approved', 'completed', 'reject'];
    return loans.sort((a, b) => statusOrder.indexOf(a.status) - statusOrder.indexOf(b.status));
  }


  selectedStatus = 'approved';
  selectStatus(status: string) {
    this.selectedStatus = status;
  }
  isLoanApprovedPermission(type: string): boolean {
    const user_role = JSON.parse(this.user.user_role.user_roles);
    const values = user_role?.team_managment?.data?.values;
    switch (type) {
      case "isloanView":
        return values.loanView ?? false
      case "isAccept":
        return values.loanAccept ?? false
      case "isReject":
        return values.loanReject ?? true
      default:
        return false;
    }
    return false;

  }

  selectimage(img: any) {
    this.selectimg = img
  }
  downloadImage() {

    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';

    xhr.onload = () => {
      const blob = xhr.response;
      const blobUrl = window.URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'image.jpg';
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(blobUrl);
    };

    xhr.open('GET', this.selectimg, true);
    xhr.send();
  }


  setModalData(data: any) {
    this.modalData = data;
  }

  // loandetail(id: any) {
  //   this.showSpinner = true;

  //   this.addService.getLoanReq(id).then((value) => {
  //     this.loanDetail = value.data
  //     this.totalAmount = this.loanDetail.total_amount
  //     this.total_duration = this.loanDetail.total_duration
  //     this.paid_installment = this.loanDetail.paid_months
  //     this.remaining_amount = this.loanDetail.remaining_amount
  //     this.remaining_months = this.loanDetail.remaining_months
  //     this.showSpinner = false;
  //   })
  // }



  // isLoanRejectPermission(): boolean {
  //   var user_role = JSON.parse(this.user.user_role.user_roles)
  //   if (user_role.role_type === "Employee") {
  //     return false
  //   } else if (user_role.role_type === "Team_Lead") {
  //     return false
  //   } else {
  //     return user_role.leave_data.data.values.reject
  //   }
  // }

  approveLoan(id: any, action: string) {
    this.showSpinner = true;
    if (action === 'approved') {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/success-modal.svg"  alt="image" >',
        title: 'Loan Request Approved Successfully',
        showConfirmButton: false,
        timer: 3000,

      });


    } else if (action === 'reject') {
      Swal.fire({
        iconHtml: ' <img src="../../../../assets/images/error-modal.svg"  alt="image" >',
        title: 'Loan Request Rejected Successfully',
        showConfirmButton: false,
        timer: 3000,

      });

    }
    this.addService.getLoanApprove(id, action).then((value) => {
      window.location.reload();

      this.showSpinner = false;
    })


  }
  getCircleArray(loanDuration: number): number[] {
    return Array.from({ length: loanDuration }, (_, index) => index);
  }

  getloanFilter() {
    this.showSpinner = true;
    const name = this.nameFilter;
    this.addService.loanFilter(name).then((value) => {
      this.loans = value.data
      this.showSpinner = false;
    })
  }

  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }





}
